export default __webpack_public_path__ + "static/media/arrowup.724d63f9.svg";